<template>
  <div id="app">
    <top-banner />
    <navbar-overlay></navbar-overlay>
    <router-view class="page-wrapper"></router-view>
    <footerr></footerr>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import TopBanner from '@/components/Banner'
// import NavbarFull from '@/components/NavBarFull.vue'
import NavbarOverlay from '@/components/NavBarOverlay.vue'
// import TopSection from '@/components/TopSection.vue'
import Footerr from '@/components/footer.vue'
export default {
  name: 'app',
  components: {
    TopBanner,
    // NavbarFull,
    NavbarOverlay,
    // TopSection,
    Footerr,
  },
  data () {
    return {
    }
  },
  // computed: mapGetters([
  //   'isAuthenticated'
  // ]),
  // methods: {
  //   // http://redux.js.org/docs/recipes/UsingObjectSpreadOperator.html
  //   ...mapActions([
  //     'authenticated',
  //     'unauthenticated'
  //   ])
  // },
  beforeCreate () {
    /* global window */
    window.onLoadCallback = function () {
      console.log('callback function here...')
    }
  },
  async created () {
    // console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })

    // on master event resize (propagating to EventBus)
    EventBus.isDesktop = (window.innerWidth > 768)
    EventBus.windowWidth = (window.innerWidth)
    window.addEventListener('resize', function (event) {
      EventBus.isDesktop = (event.target.innerWidth > 768)
      EventBus.windowWidth = (window.innerWidth)
    })
  },
  beforeMount () {
    // console.log('beforeMount App.vue')
    window.addEventListener('load', () => {
    })
  },
  async mounted () {
    await EventBus.init()
  }
}
</script>

<style lang="scss">
@import "./styles/app.scss";

html.modal-open {
  overflow: hidden;
  position: relative;
  height: 100%;
  body {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
}

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  // margin-top: 60px;

  // position: relative;
  // .my-toolbar {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  // }
}

body, .page-wrapper {
  background-color: transparent;
}
</style>
